import { MultimediaComponentType, ReplyTextComponentType, Screen, SelectionComponentType, SwitchComponentType, TextComponentType } from '../interfaces/FlowInterfaces'
import { Flow } from '../interfaces/FlowInterfaces'
// Wizard template with example form fields.
export const defaultBasic: Flow =
{
  version: '7.0',
  screens: [
    {
      id: 'SCREEN_A',
      title: 'Pantalla 1',
      data: {},
      terminal: true,
      layout: {
        type: 'SingleColumnLayout',
        children: [
          {
            type: 'Form',
            name: 'form',
            children: [
              {
                type: 'TextHeading',
                text: 'Text Heading 1'
              },
              {
                type: 'TextInput',
                label: 'Etiqueta',
                name: 'TextInput_label',
                required: true,
                'input-type': 'text'
              },
              {
                type: 'Footer',
                label: 'Continuar',
                'on-click-action': {
                  name: 'complete',
                  payload: {}
                }
              }
            ]
          }
        ]
      }
    }
  ]
}

export const medicalAppointment: Flow = 
  {
    version: '7.0',
    screens: [
      {
        'id': 'SANNA_CITAS',
        'title': 'Agenda tu cita',
        'data': {},
        'terminal': true,
        'layout': {
          'type': 'SingleColumnLayout',
          'children': [
            {
              'type': 'Form',
              'name': 'flow_path',
              'children': [
                {
                  'type': 'TextSubheading',
                  'text': 'Información del paciente'
                },
                {
                  'type': 'TextInput',
                  'label': 'Nombres',
                  'name': 'TextInput_fd5159',
                  'required': true,
                  'input-type': 'text'
                },
                {
                  'type': 'TextInput',
                  'label': 'Apellidos',
                  'name': 'TextInput_6629c4',
                  'required': true,
                  'input-type': 'text'
                },
                {
                  'type': 'TextInput',
                  'label': 'Dni',
                  'name': 'TextInput_a2f24f',
                  'required': true,
                  'input-type': 'number'
                },
                {
                  'type': 'TextSubheading',
                  'text': 'Separar cita'
                },
                {
                  'type': 'Dropdown',
                  'label': 'Especialidad',
                  'required': true,
                  'name': 'Dropdown_216e9a',
                  'data-source': [
                    {
                      'id': '0_Traumatología',
                      'title': 'Traumatología'
                    },
                    {
                      'id': '1_Rehabilitación',
                      'title': 'Rehabilitación'
                    },
                    {
                      'id': '2_Nutrición',
                      'title': 'Nutrición'
                    }
                  ]
                },
                {
                  'type': 'DatePicker',
                  'label': 'Fecha',
                  'required': true,
                  'name': 'DatePicker_ee4a5b'
                },
                {
                  'type': 'RadioButtonsGroup',
                  'label': 'Indicar horario',
                  'required': true,
                  'name': 'RadioButtonsGroup_d8108d',
                  'data-source': [
                    {
                      'id': '0_9:00_am',
                      'title': '9:00 am'
                    },
                    {
                      'id': '1_10:00_am',
                      'title': '10:00 am'
                    }
                  ]
                },
                {
                  'type': 'Footer',
                  'label': 'Continue',
                  'on-click-action': {
                    'name': 'complete',
                    'payload': {
                      'screen_0_TextInput_0': '${form.TextInput_fd5159}',
                      'screen_0_TextInput_1': '${form.TextInput_6629c4}',
                      'screen_0_TextInput_2': '${form.TextInput_a2f24f}',
                      'screen_0_Dropdown_3': '${form.Dropdown_216e9a}',
                      'screen_0_DatePicker_4': '${form.DatePicker_ee4a5b}',
                      'screen_0_RadioButtonsGroup_5': '${form.RadioButtonsGroup_d8108d}'
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    ]

  }

export const feedBack: Flow = 
  {
    version: '7.0',
    screens:  [
      {
        'id': 'RECOMMEND',
        'title': 'Comentarios 1 of 2',
        'data': {},
        'layout': {
          'type': 'SingleColumnLayout',
          'children': [
            {
              'type': 'Form',
              'name': 'form',
              'children': [
                {
                  'type': 'TextSubheading',
                  'text': '¿Nos recomendarías a un amigo?'
                },
                {
                  'type': 'RadioButtonsGroup',
                  'label': 'Elige uno',
                  'name': 'Choose_one',
                  'data-source': [
                    {
                      'id': '0_Yes',
                      'title': 'Si'
                    },
                    {
                      'id': '1_No',
                      'title': 'No'
                    }
                  ],
                  'required': true
                },
                {
                  'type': 'TextSubheading',
                  'text': '¿Cómo podríamos hacerlo mejor?'
                },
                {
                  'type': 'TextArea',
                  'label': 'Deja un comentario',
                  'required': false,
                  'name': 'Leave_a_comment'
                },
                {
                  'type': 'Footer',
                  'label': 'Continua',
                  'on-click-action': {
                    'name': 'navigate',
                    'next': {
                      'type': 'screen',
                      'name': 'RATE'
                    },
                    'payload': {
                      'screen_0_Choose_one_0': '${form.Choose_one}',
                      'screen_0_Leave_a_comment_1': '${form.Leave_a_comment}'
                    }
                  }
                }
              ]
            }
          ]
        }
      },
      {
        'id': 'RATE',
        'title': 'Comentarios 2 of 2',
        'data': {
          'screen_0_Choose_one_0': {
            'type': 'string',
            '__example__': 'Example'
          },
          'screen_0_Leave_a_comment_1': {
            'type': 'string',
            '__example__': 'Example'
          }
        },
        'terminal': true,
        'success': true,
        'layout': {
          'type': 'SingleColumnLayout',
          'children': [
            {
              'type': 'Form',
              'name': 'form',
              'children': [
                {
                  'type': 'TextSubheading',
                  'text': 'Califica lo siguiente:: '
                },
                {
                  'type': 'Dropdown',
                  'label': 'Experiencia de compra',
                  'required': true,
                  'name': 'Purchase_experience',
                  'data-source': [
                    {
                      'id': '0_Excellent',
                      'title': '★★★★★ • Excelente (5/5)'
                    },
                    {
                      'id': '1_Good',
                      'title': '★★★★☆ • Buena (4/5)'
                    },
                    {
                      'id': '2_Average',
                      'title': '★★★☆☆ • Regular (3/5)'
                    },
                    {
                      'id': '3_Poor',
                      'title': '★★☆☆☆ • Mala (2/5)'
                    },
                    {
                      'id': '4_Very_Poor',
                      'title': '★☆☆☆☆ • Muy mala (1/5)'
                    }
                  ]
                },
                {
                  'type': 'Dropdown',
                  'label': 'Entrega e instalación',
                  'required': true,
                  'name': 'Delivery_and_setup',
                  'data-source': [
                    {
                      'id': '0_Excellent',
                      'title': '★★★★★ • Excelente (5/5)'
                    },
                    {
                      'id': '1_Good',
                      'title': '★★★★☆ • Buena (4/5)'
                    },
                    {
                      'id': '2_Average',
                      'title': '★★★☆☆ • Regular (3/5)'
                    },
                    {
                      'id': '3_Poor',
                      'title': '★★☆☆☆ • Mala (2/5)'
                    },
                    {
                      'id': '4_Very_Poor',
                      'title': '★☆☆☆☆ • Muy mala (1/5)'
                    }
                  ]
                },
                {
                  'type': 'Dropdown',
                  'label': 'Servicio al cliente',
                  'required': true,
                  'name': 'Customer_service',
                  'data-source': [
                    {
                      'id': '0_Excellent',
                      'title': '★★★★★ • Excelente (5/5)'
                    },
                    {
                      'id': '1_Good',
                      'title': '★★★★☆ • Obuena (4/5)'
                    },
                    {
                      'id': '2_Average',
                      'title': '★★★☆☆ • Regular (3/5)'
                    },
                    {
                      'id': '3_Poor',
                      'title': '★★☆☆☆ • Mala (2/5)'
                    },
                    {
                      'id': '4_Very_Poor',
                      'title': '★☆☆☆☆ • Muy mala (1/5)'
                    }
                  ]
                },
                {
                  'type': 'Footer',
                  'label': 'Done',
                  'on-click-action': {
                    'name': 'complete',
                    'payload': {
                      'screen_1_Purchase_experience_0': '${form.Purchase_experience}',
                      'screen_1_Delivery_and_setup_1': '${form.Delivery_and_setup}',
                      'screen_1_Customer_service_2': '${form.Customer_service}',
                      'screen_0_Choose_one_0': '${data.screen_0_Choose_one_0}',
                      'screen_0_Leave_a_comment_1': '${data.screen_0_Leave_a_comment_1}'
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    ]
  }

export const customerService: Flow = 
  {
    version: '7.0',
    screens: [
      {
        'id': 'DETAILS',
        'title': 'Obtener ayuda',
        'data': {},
        'terminal': true,
        'success': true,
        'layout': {
          'type': 'SingleColumnLayout',
          'children': [
            {
              'type': 'Form',
              'name': 'form',
              'children': [
                {
                  'type': 'TextInput',
                  'name': 'Name',
                  'label': 'Nombre',
                  'input-type': 'text',
                  'required': true
                },
                {
                  'type': 'TextInput',
                  'label': 'Número de pedido',
                  'name': 'Order_number',
                  'input-type': 'number',
                  'required': true
                },
                {
                  'type': 'RadioButtonsGroup',
                  'label': 'Elige un tema',
                  'name': 'Choose_a_topic',
                  'data-source': [
                    {
                      'id': '0_Orders_and_payments',
                      'title': 'Pedidos y pagos'
                    },
                    {
                      'id': '1_Maintenance',
                      'title': 'Mantenimiento'
                    },
                    {
                      'id': '2_Delivery',
                      'title': 'Entrega'
                    },
                    {
                      'id': '3_Returns',
                      'title': 'Devoluciones'
                    },
                    {
                      'id': '4_Other',
                      'title': 'Otro'
                    }
                  ],
                  'required': true
                },
                {
                  'type': 'TextArea',
                  'label': 'Descripción del problema',
                  'required': false,
                  'name': 'Description_of_issue'
                },
                {
                  'type': 'Footer',
                  'label': 'Hecho',
                  'on-click-action': {
                    'name': 'complete',
                    'payload': {
                      'screen_0_Name_0': '${form.Name}',
                      'screen_0_Order_number_1': '${form.Order_number}',
                      'screen_0_Choose_a_topic_2': '${form.Choose_a_topic}',
                      'screen_0_Description_of_issue_3': '${form.Description_of_issue}'
                    }
                  }
                }
              ]
            }
          ]
        }
      }
    ]
  }

export const defScreenObject: Screen = {
  id: 'SCREEN_ID',
  title: 'Pantalla 1',
  data: {},
  terminal: false,
  layout: {
    type: 'SingleColumnLayout',
    children: [
      {
        type: 'Form',
        name: 'Form 1',
        children: [
          {
            type: 'TextHeading',
            text: 'Text Heading 1'
          },
          {
            type: 'Footer',
            label: 'Footer 1',
            'on-click-action': {
              name: 'navigate',
              payload: {}
            }
          }
        ]
      }
    ]
  }
}